import { render, staticRenderFns } from "./Chart_menu.vue?vue&type=template&id=31f49c20&scoped=true&lang=pug&"
import script from "./Chart_menu.vue?vue&type=script&lang=js&"
export * from "./Chart_menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f49c20",
  null
  
)

export default component.exports